import { Component, computed, input } from '@angular/core';
import { TextDirective } from '../../typography/text.directive';

@Component({
  selector: 'joii-product-custom-attachments',
  template: `
    <img [src]="productImage()" [alt]="imageAlt()" />
    <section class="product-footer">
      <p joii-text [size]="5" [color]="'positive'" [weight]="'semibold'">{{ productName() }}</p>
      <span joii-text [size]="4" [color]="'positive'">{{ priceDisplay() }}</span>
    </section>
  `,
  host: {
    '(click)': 'openProduct()',
    '(keydown.enter)': 'openProduct()',
    '[tabIndex]': '0',
    role: 'link',
  },
  styles: `
    img {
      width: 100%;
      object-fit: cover;
    }
    .product-footer {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 8px 16px;
      cursor: pointer;
      background-color: var(--Vetai-Secondary--Hover);
    }
  `,
  imports: [TextDirective],
})
export class ProductCustomAttachmentsComponent {
  productName = input<string>();
  productPrice = input<number>();
  productImage = input<string>();
  productUrl = input<string>();
  currency = input<string>();

  imageAlt = computed(() => {
    const name = this.productName()?.trim();
    return name ? `${name} product image` : 'Product image';
  });

  priceDisplay = computed(() => {
    let price = (this.productPrice() ?? 0) / 100;
    return `${this.currency() === 'GBP' ? '£' : ''}${price.toFixed(2)}`;
  });

  openProduct() {
    window.open(this.productUrl(), '_blank');
  }
}
